import { FC } from 'react';

import Callout from 'components/_core/Callout';

import locales from './locales';

type MemberAlreadyExistsCalloutProps = {
  hasOngoingInvitation: boolean;
  isLocked: boolean;
  firstName: string;
  lastName: string;
  onEditExistingUser: () => void;
  onCancel: () => void;
  onEditLockedUser: () => void;
  onBackToLockedUsers: () => void;
};

const getTranslatedContent = ({
  hasOngoingInvitation,
  isLocked,
}: {
  hasOngoingInvitation: boolean;
  isLocked: boolean;
}): string => {
  if (isLocked) {
    if (hasOngoingInvitation) {
      return locales.descriptionLockedWithInvitation;
    }
    return locales.descriptionLocked;
  }
  if (hasOngoingInvitation) {
    return locales.descriptionInvitation;
  }
  return locales.descriptionUser;
};

const getTranslatedButton = ({
  hasOngoingInvitation,
  isLocked,
  onBackToLockedUsers,
  onCancel,
  onEditExistingUser,
  onEditLockedUser,
}: {
  hasOngoingInvitation: boolean;
  isLocked: boolean;
  onEditExistingUser: () => void;
  onCancel: () => void;
  onEditLockedUser: () => void;
  onBackToLockedUsers: () => void;
}) => {
  if (isLocked) {
    if (hasOngoingInvitation) {
      return (
        <Callout.Button onClick={onBackToLockedUsers}>
          {locales.goBackToRevokedList}
        </Callout.Button>
      );
    }
    return (
      <Callout.Button onClick={onEditLockedUser}>
        {locales.inviteToANewRole}
      </Callout.Button>
    );
  }
  if (!hasOngoingInvitation) {
    return (
      <Callout.Button onClick={onEditExistingUser}>
        {locales.editRoleAction}
      </Callout.Button>
    );
  }
  return <Callout.Button onClick={onCancel}>{locales.goBack}</Callout.Button>;
};

export const MemberAlreadyExistsCallout: FC<
  MemberAlreadyExistsCalloutProps
> = ({
  firstName,
  hasOngoingInvitation,
  isLocked,
  lastName,
  onBackToLockedUsers,
  onCancel,
  onEditExistingUser,
  onEditLockedUser,
}) => {
  const contentTranslationString = getTranslatedContent({
    hasOngoingInvitation,
    isLocked,
  });

  return (
    <Callout variant="error">
      <Callout.Title>{locales.title}</Callout.Title>
      <Callout.Content>
        {locales.formatString(contentTranslationString, {
          firstName: firstName,
          lastName: lastName,
        })}
      </Callout.Content>
      {getTranslatedButton({
        hasOngoingInvitation,
        isLocked,
        onBackToLockedUsers,
        onCancel,
        onEditExistingUser,
        onEditLockedUser,
      })}
    </Callout>
  );
};
